<div class="d-flex gap-10 ai-center f-s-18 m-t-30 m-b-20 f-w-600 text-blackTitle">
  <i-tabler name="layout-list" class="icon-25 stroke-1" />
  Visualização dos produtos
</div>
<div class="d-flex ai-center gap-10">
  <button type="button" class="btn" [class.flat-button]="viewMode === 'list'"
    [class.stroked-button]="viewMode !== 'list'" (click)="setViewMode('list')">
    Lista
  </button>

  <button type="button" class="btn" [class.flat-button]="viewMode === 'categories'"
    [class.stroked-button]="viewMode !== 'categories'" (click)="setViewMode('categories')">
    Categorias
  </button>
</div>